import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider, useToast } from "./components/Toast/useToast";
import ToastContainer from "./components/Toast/ToastContainer";
import ErrorBoundary from "./components/ErrorBoundary";
import App from "./App";
import "./styles.css";

// Wrapper to access toast context - must be inside ToastProvider
function ToastContainerWrapper() {
  const context = useToast();
  if (!context || !context.toasts) return null;
  
  const { toasts, removeToast } = context;
  return <ToastContainer toasts={toasts} removeToast={removeToast} />;
}

// Main app wrapper with all providers
function AppWithProviders() {
  return (
    <ToastProvider>
      <ToastContainerWrapper />
      <App />
    </ToastProvider>
  );
}

function Root() {
  return (
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <AppWithProviders />
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
